import { DarkModeOutlined, LightModeOutlined } from '@mui/icons-material';
import { useThemeCtx } from 'state/theme/ThemeCtx';
import React from 'react';
import IconSwitch from '../../components/IconSwitch';

const ThemeSwitch: React.FC = () => {
	const { mode, setMode } = useThemeCtx();

	return (
		<IconSwitch
			checked={mode === 'dark'}
			onChange={(checked) => setMode(checked ? 'dark' : 'light')}
			data-testid="theme-switch"
			checkedIcon={<DarkModeOutlined />}
			uncheckedIcon={<LightModeOutlined />}
		/>
	);
};

export default ThemeSwitch;
